export { default } from './MaterialIcon'
